import React from 'react';
import { SectionInstance } from '../types';
import InlineEditText from '../InlineEditText';
import { sfHeadline, sfSub } from './sectionHelpers';

interface GalleryImage {
  image_url: string;
  caption: string;
  alt: string;
}

const GalleryGrid: React.FC<{ section: SectionInstance }> = ({ section }) => {
  const c = section.controls;
  const images = (c.images || []) as GalleryImage[];
  const variant = (c.variant as string) || '3_col';

  const cols = variant === '2_col' ? 2 : variant === '4_col' ? 4 : 3;
  const isMasonry = variant === 'masonry';

  return (
    <section className="sb-render sb-render-gallery-grid" style={{ padding: '80px 24px' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <InlineEditText
            tag="h2"
            controlKey="headline"
            style={{ fontSize: '2.25rem', marginBottom: 12 }}
          >
            {sfHeadline(c, 'Our Gallery')}
          </InlineEditText>
          <InlineEditText
            tag="p"
            controlKey="subheadline"
            style={{ fontSize: '1.125rem', color: '#64748b', maxWidth: 640, margin: '0 auto' }}
          >
            {sfSub(c, '')}
          </InlineEditText>
        </div>

        {isMasonry ? (
          <div style={{ columns: 3, columnGap: 16 }}>
            {images.map((img, i) => (
              img.image_url ? (
                <div key={i} style={{ breakInside: 'avoid', marginBottom: 16 }}>
                  <img
                    src={img.image_url}
                    alt={img.alt || img.caption || ''}
                    style={{
                      width: '100%',
                      display: 'block',
                      borderRadius: 'var(--brand-card-radius, 12px)',
                    }}
                  />
                  {img.caption && (
                    <p style={{ fontSize: '0.8rem', color: '#64748b', margin: '4px 0 0' }}>
                      {img.caption}
                    </p>
                  )}
                </div>
              ) : null
            ))}
          </div>
        ) : (
          <div style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${cols}, 1fr)`,
            gap: 16,
          }}>
            {images.map((img, i) => (
              img.image_url ? (
                <div key={i} style={{
                  borderRadius: 'var(--brand-card-radius, 12px)',
                  overflow: 'hidden',
                }}>
                  <img
                    src={img.image_url}
                    alt={img.alt || img.caption || ''}
                    style={{
                      width: '100%',
                      aspectRatio: '4/3',
                      objectFit: 'cover',
                      display: 'block',
                    }}
                  />
                  {img.caption && (
                    <p style={{ fontSize: '0.8rem', color: '#64748b', margin: '8px 0 0' }}>
                      {img.caption}
                    </p>
                  )}
                </div>
              ) : null
            ))}
          </div>
        )}

        {images.length === 0 && (
          <div style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${isMasonry ? 3 : cols}, 1fr)`,
            gap: 16,
          }}>
            {[1, 2, 3].map(i => (
              <div key={i} style={{
                background: '#f1f5f9',
                borderRadius: 'var(--brand-card-radius, 12px)',
                aspectRatio: '4/3',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#94a3b8',
                fontSize: '0.875rem',
              }}>
                Image {i}
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default GalleryGrid;
